export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4710.42dc6d81.jpg";